import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { LcsResponsiveTableModule } from '@lcs/shared/table';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { CallHistoryFilterModule } from 'src/app/common-components/call-history-filters/call-history-filter.module';
import { OutgoingFaxDetailDialogModule } from 'src/app/common-components/outgoing-fax-detail-dialog/outgoing-fax-detail-dialog.module';
import { RegisterModule } from 'src/app/common-components/register/register.module';
import { FileUrlPipeModule } from 'src/app/pipes/file-url-pipe/file-url-pipe.module';
import { FormatPhoneNumbersPipeModule } from 'src/app/pipes/format-phone-numbers/format-phone-numbers-pipe.module';
import { AddSpacesPipeModule } from 'src/app/pipes/split-enum-strings/add-spaces-pipe.module';
import { EntitySelectModule } from '../../../common-components/entity-select/entity-select.module';
import { IncomingFaxRegisterComponent } from './containers/incoming-fax-register.component';
import { IncomingFaxRegisterEffects } from './state/incoming-fax-register.effects';
import { incomingFaxRegisterFeatureKey, incomingFaxRegisterReducer } from './state/incoming-fax-register.reducer';
import { IncomingFaxRegisterViewComponent } from './views/incoming-fax-register-view.component';
@NgModule({
   declarations: [IncomingFaxRegisterViewComponent, IncomingFaxRegisterComponent],
   exports: [IncomingFaxRegisterViewComponent, IncomingFaxRegisterComponent],
   imports: [
      FormatPhoneNumbersPipeModule,
      CallHistoryFilterModule,
      CommonModule,
      EntitySelectModule,
      FileUrlPipeModule,
      OutgoingFaxDetailDialogModule,
      FormsModule,
      LcsCallStatePipeModule,
      LcsLoadingOverlayModule,
      LcsResponsiveTableModule,
      MatButtonModule,
      MatDatepickerModule,
      MatInputModule,
      MatMenuModule,
      MatTooltipModule,
      MatIconModule,
      ReactiveFormsModule,
      RouterModule,
      ScrollingModule,
      AddSpacesPipeModule,
      RegisterModule,
      EffectsModule.forFeature([IncomingFaxRegisterEffects]),
      StoreModule.forFeature(incomingFaxRegisterFeatureKey, incomingFaxRegisterReducer),
      EntitySelectModule,
   ],
})
export class IncomingFaxRegisterModule {}
